<template>
  <BContent
    v-loading="loading"
    invisible-navbar
    class="cockpit"
  >
    <LeadViewList />
    <ActionRequired v-if="isAvailableCallFeedbackFeature && isAvailableTranscriptionFeature && isAvailableCockpitNextActionSuggestionsFeature && authorize(['owner', 'member'])" />
    <NextActionSuggestionsList v-if="!isAvailableCallFeedbackFeature && isAvailableTranscriptionFeature && isAvailableCockpitNextActionSuggestionsFeature" />
    <SisenseContextProvider
      :url="sisenseUrl"
      :app-config="appConfig"
      sso-enabled
    >
      <template v-if="sisenseAuthChecked">
        <NextActionCharts />
      </template>
    </SisenseContextProvider>
  </BContent>
</template>

<script setup lang="ts">
import {
  SisenseContextProvider,
} from '@sisense/sdk-ui-vue';
import { computed } from 'vue';
import ActionRequired from '@/components/organisms/user/cockpit/ActionRequired.vue';
import LeadViewList from '@/components/organisms/user/cockpit/LeadViewList.vue';
import NextActionCharts from '@/components/organisms/user/cockpit/NextActionCharts.vue';
import NextActionSuggestionsList from '@/components/organisms/user/cockpit/NextActionSuggestionsList.vue';
import { useAvailableFeatureCheck } from '@/composable/available-feature-check';
import { useCurrentUserProvider } from '@/composable/current-user';
import { useSisense } from '@/composable/user/sisense/sisense';
import { useWait } from '@/composable/vue-wait';
import intercom from '@/mixins/intercom';

const { inject: injectCurrentUser } = useCurrentUserProvider();
const { authorize } = injectCurrentUser();
const { sisenseAuthChecked } = useSisense();
const { wait } = useWait();
const {
  isAvailableTranscriptionFeature,
  isAvailableCockpitNextActionSuggestionsFeature,
  isAvailableCallFeedbackFeature,
} = useAvailableFeatureCheck();
const sisenseUrl = `${import.meta.env.VITE_SISENSE_URL}`;

// intercomのセットアップを呼び出す
intercom.setup({});

const loading = computed(() => {
  return wait.is('checkSisenseAccount');
});

const appConfig = {
  dateConfig: {
    timeZone: 'JST',
  },
};
</script>

<style lang="scss" scoped>
.cockpit {
  background-color: #F5F7FA;
}
:deep(.b-height-adjuster > .content) {
  height: 100%;
  padding: $basespace-300 $basespace-600;
}
</style>
